<template>
  <button class="font-bold text-xs my-1 py-3 px-4 uppercase mx-2 ml-0">
    <slot></slot>
  </button>
</template>
